<template>
  <HeadCont v-if="showHeadCont" />
  <HistoryCont v-if="showHeadCont && (userLoginInfo ? true : false)" />
  <router-view />
  <!-- <StaffServiceCont /> -->
</template>
<script setup>
import { onMounted, onBeforeMount, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import { useRouter } from "vue-router";

const store = useStore();
const { userLoginInfo } = storeToRefs(store);
const { setUserLoginInfo } = store;
const baseApi = process.env.VUE_APP_BASE_API;
const router = useRouter();

// 需要隐藏 HeadCont 的路由列表
const hideHeadRoutes = ["wxGo"];

// 控制 HeadCont 显隐
const showHeadCont = ref(false);

// 判断当前路由是否需要显示 HeadCont
const checkHeadContShow = (route) => {
  showHeadCont.value = !hideHeadRoutes.includes(route.name);
};

onBeforeMount(() => {
  checkHeadContShow(router.currentRoute.value);
});

onMounted(() => {
  let loginUser = localStorage.getItem("loginUser");
  if (loginUser) {
    setUserLoginInfo(loginUser);
  }
});

// 监听路由变化
watch(
  () => router.currentRoute.value,
  (newRoute) => {
    checkHeadContShow(newRoute);
  },
  { immediate: true }
);

</script>
<style lang="scss"></style>